// Définir les interfaces pour les objets

export interface StypeItem {
    nSType: number;
    sSType: string;
    nType: number;
    nSpelAccepte: number;
    nForfait: number;
  }
  
  interface GetNSTypeResult {
    sMessage: string;
    sInfo: string;
    tabStype: StypeItem[];
  }
  
  interface SoapEnvelope {
    "SOAP-ENV:Envelope": {
      "SOAP-ENV:Body": {
        Get_nSTypeResult: GetNSTypeResult;
      }
    }
  }
  
  // Exemple de résultat de Get_nSTypeResult
  const getNSTypeResult: GetNSTypeResult = {
    sMessage: '',         
    sInfo: '',            
    tabStype: [
        {
            nSType: 0,
            sSType: '',
            nType: 0,
            nSpelAccepte: 0,
            nForfait: 0
        }
    ]
  };
  
  // Exemple de réponse enveloppe SOAP
  const soapEnvelope: SoapEnvelope = {
    "SOAP-ENV:Envelope": {
        "SOAP-ENV:Body": {
            Get_nSTypeResult: getNSTypeResult // Utiliser l'exemple de GetNSTypeResult
        }
    }
  };
  
  // Exports pour utilisation dans d'autres fichiers
  export {
    getNSTypeResult,
    soapEnvelope,
    
  };
  